export default {
  "using-the-javascript-sdk": "JavaScript SDKs",
  "automation-sdk": "Automation SDK",
  "advanced-automation": "Advanced Automation",
  "stealth-headless-browsers": "Stealth Headless Browsers",
  "using-the-mobile-sdk": {
    display: "hidden",
  },
  "using-server-side-sdk": {
    display: "hidden",
  },
  "blockchain-verification": {
    display: "hidden",
  },
  "using-playwright": { display: "hidden" },
};
